import React from "react";
import UploadFile from "./components/UploadFile";

import Stack from "../../../components/lib/Stack";
import Inline from "../../../components/lib/Inline";
import Box from "../../../components/lib/Box";
import Button from "../../../components/lib/Button";
import { UploadUserProvider, useUploadUserContext } from "./context/UploadUserContext";

const AdminCreateBulkUsers = () => {
  return (
    <UploadUserProvider>
      <CreateBulkUsers />
    </UploadUserProvider>
  );
};

const CreateBulkUsers = () => {
  const { response, router } = useUploadUserContext();
  return (
    <Stack css={{ width: "$full", alignItems: "flex-start" }}>
      <div className="view">
        <div className="rc-container bring-forward">
          <Inline css={{ width: "$full", justifyContent: "space-between" }}>
            <Box css={{ fontSize: "18px", fontWeight: "bold" }}>
              <h2>Add Multiple Users</h2>
              <label>
                <i>
                  Create multiple users at once by uploading a xls/csv file or entering
                  data manually.
                </i>
              </label>
            </Box>
            <Box css={{ fontSize: "14px", color: "#666" }}>
              <Button color="brand" size="normal" onClick={() => router.goBack()}>
                Back to User List
              </Button>
            </Box>
          </Inline>
          <UploadFile />

          {(response?.rejected_data?.length > 0 ||
            response?.already_exists?.length > 0) && (
            <Box css={{ fontSize: "14px", color: "#666", textAlign: "right" }}>
              <Button color="brand" size="normal" onClick={() => router.goBack()}>
                Back to User List
              </Button>
            </Box>
          )}
        </div>
      </div>
    </Stack>
  );
};

export default AdminCreateBulkUsers;
